import { FormErrorLabel, FormInput, FormSelect, Heading, Loader } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import { BLOCK_NAME, COMMUNITY_ID, DELETED, DESCRIPTION, LIST, NEW, ZONE_ID } from "./consts";
import { Button } from "@/components/ui";
import { Trash2 } from "lucide-react";

const AddEdit = () => {
  const {
    breadcrumbData,
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    onCancel,
    communitiesData,
    isLoadingCommunities,
    onRemove,
    onAddMore,
    isDeletePending,
    list,
    keys,
    isLoadingBlock,
    isLoadingZone,
    isEdit,
    zoneList,
    communityId,
    hasDeletePermission
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      <Heading
        title={breadcrumbData[breadcrumbData.length - 1]?.name || ""}
        showBack
        breadcrumbData={breadcrumbData}
        onBackClick={onBackClick}
      />

      {isLoadingCommunities || isDeletePending || isLoadingBlock ? <Loader /> : <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="bg-white mt-[20px] rounded-lg pt-[25px] gap-[30px] grid grid-cols-1">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] px-[30px]">
              <FormSelect
                key={keys.community}
                showSearch
                name={COMMUNITY_ID}
                control={form.control}
                label="Community"
                placeholder="Please select"
                error={errors[COMMUNITY_ID]?.message}
                isRequired={requiredFields.includes(COMMUNITY_ID)}
                options={communitiesData?.map((data: any) => ({
                  label: data?.name,
                  value: data?.communityId?.toString(),
                }))}
                disabled={isEdit}
              />
              <FormSelect
                showSearch
                key={keys.zone}
                name={ZONE_ID}
                control={form.control}
                label="Zone"
                placeholder="Please select"
                error={errors[ZONE_ID]?.message}
                isRequired={requiredFields.includes(ZONE_ID)}
                options={zoneList?.map((data: any) => ({
                  label: data?.zoneName,
                  value: data?.zoneId?.toString(),
                }))}
                disabled={!communityId || isLoadingZone || isEdit}
              />
            </div>
            <div className="bg-blue-50 gap-[30px] grid grid-cols-1 items-start px-[30px] py-[25px] rounded-lg">
              {list?.map((_: any, index: number) => {
                if (_[DELETED]) return;
                return <div className="grid grid-cols-1 md:grid-cols-3 gap-[20px]">
                  <FormInput
                    name={`${LIST}.${index}.${BLOCK_NAME}`}
                    control={form.control}
                    label="Block Name"
                    placeholder="Please enter"
                    error={(errors as any)[LIST]?.[index]?.[BLOCK_NAME]?.message}
                    isRequired={requiredFields.includes(`${LIST}.${BLOCK_NAME}`)}
                    className="bg-white"
                    disabled={isEdit && !form.watch(`${LIST}.${index}.${NEW}`)}
                  />
                  <FormInput
                    name={`${LIST}.${index}.${DESCRIPTION}`}
                    control={form.control}
                    label="Description"
                    placeholder="Please enter"
                    error={(errors as any)[LIST]?.[index]?.[DESCRIPTION]?.message}
                    isRequired={requiredFields.includes(`${LIST}.${DESCRIPTION}`)}
                    className="bg-white"
                    disabled={isEdit && !form.watch(`${LIST}.${index}.${NEW}`)}
                  />
                  {hasDeletePermission && <Button
                    type="button"
                    variant="ghost"
                    onClick={() => onRemove(index)}
                    className="p-0 w-[35px] col-span-1 bg-transparent hover:bg-transparent"
                  >
                    <Trash2 className="w-5 h-5 stroke-red-500" />
                  </Button>}
                </div>
              })}
              <div className="flex flex-col items-start">
                <FormErrorLabel className="relative">{(errors as any)[LIST]?.message}</FormErrorLabel>
                <Button
                  variant="ghost"
                  className="p-0 text-primary hover:bg-transparent hover:text-primary mt-2"
                  onClick={onAddMore}
                  type="button"
                >
                  + Add More
                </Button>
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-end gap-3  py-3">
            <Button
              variant="outline"
              type="button"
              onClick={onCancel}
              disabled={isAddPending}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isAddPending}>
              {isAddPending && <Loader variant="secondary" />}
              Save
            </Button>
          </div>
        </form>
      </FormProvider>}
    </div>
  );
};

export default AddEdit;
